<template>
  <div class="productsCenter">
    <topbar :imp="navText"></topbar>
    <img class="ban" src="./img/ban.jpg">
    <div class="wrap">
      <div class="conTitle">产品中心</div>
      <div class="conTitle_bor"></div>
      <div class="conText conTextPro">上海航数智能科技有限公司以“以中国工业数字化为使命”，提供基于工业互联网的健康管理系统一体化解决方案，以及各类相关的数据分析、数据挖掘及大数据平台研发等服务。</div>
      <div class="hei100"></div>
    </div>
    <div class="bgDiv">
      <div class="wrap clear">
        <img class="imgL fl" src="./img/img01.jpg">
        <div class="listR fr">
          <div class="listTitle">健康管理系统</div>
          <p class="listP">工业设备健康管理系统以“预防及预测未病之病”为宗旨，通过成熟的通讯协议，连接海量设备。使用大数据和人工智能等手段对设备上传的工业数据进行深度分析和决策，高效发现和预防设备的健康问题，并提供精准的维修建议和方案，实现智能服务的核心内容，重构工业运营和维护。</p>
        </div>
      </div>
    </div>
    <div class="wrap clear wrapHei">
      <img class="imgR fr" src="./img/img02.jpg">
      <div class="listL fl">
        <div class="listTitle">工业互联网平台</div>
        <p class="listP">航数工业互联网平台，在完成基础的数据传输、数据展示等常规基本功能外，在云端通过定制化的智能算法把各类工业设备现场采集的数据进行计算，通过预先设置的报警值对设备的运行状态进行实时监控。通过web端、APP端和手机短信等多种方式满足客户对工业设备的监测需求，提高生产效率，实现工业互联网化。</p>
      </div>
    </div>
    <div class="bgDiv">
      <div class="wrap clear">
        <img class="imgL fl" src="./img/img03.jpg">
        <div class="listR fr">
          <div class="listTitle">工业大数据</div>
          <p class="listP">工业大数据的数据来源丰富。既有来自于工业设备本身的各类监测数据，也有针对各种工业设备的维护记录和相关的业务系统的汇总分析。工业大数据平台能存储海量数据，可高并发，扩展方便，可以完成增删查改的数据请求，能方便进行分布式计算的系统平台。</p>
        </div>
      </div>
    </div>
    <div class="wrap clear wrapHei">
      <img class="imgR fr" src="./img/img04.jpg">
      <div class="listL fl">
        <div class="listTitle">工业网关</div>
        <p class="listP">根据通信标准，数据协议，采集内容定制出符合实际需求的频率、功能。</p>
      </div>
    </div>
    <botcon></botcon>
  </div>
</template>

<script>
import Topbar from '@/components/base/Topbar/index'
import Botcon from '@/components/base/Botcon/index'
export default {
  name: 'ProductsCenter',
  components: {
    Topbar,
    Botcon
  },
  data () {
    return {
      navText: {
        text: '产品中心'
      }
    }
  },
  created () {
    this.$nextTick(() => {
      setTimeout(() => {
        let r = window.innerWidth - document.body.clientWidth
        this.$store.commit('setScroll', r)
      }, 20)
    })
    this.menu()
  },
  methods: {
    menu () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ban{ display: block; width: 100%; height: auto;}
.conTitle{ height: 180px; text-align: center; font-size: 50px; line-height: 52px; padding-top: 89px; color: #3e3e3e;}
.conTitle_bor{ width: 90px; height: 1px; margin: 0 auto; background: #ccc;}
.conText{ padding: 20px 130px 91px; color: #5e5e5e; font-size: 22px; line-height: 40px;font-weight: lighter;}

.bgDiv{ width: 100%; height: 581px; padding: 60px 0 0; background: #eef0f5;}
.wrapHei{ height: 581px; padding: 96px 0 0;}
.bgDiv img{ display: block; height: auto;}
.listR{ width: 658px;}
.imgL{ width: 497px;}
.listL{ width: 589px;}
.imgR{ width: 479px;}
.listTitle{ font-size: 40px; color: #3e3e3e; line-height: 90px; padding-bottom: 18px;}
.listP{ font-size: 21px; color: #5e5e5e; line-height: 39px;text-align:justify;font-weight: lighter;}
</style>



// WEBPACK FOOTER //
// src/components/ProductsCenter/index.vue